import { render, staticRenderFns } from "./ModalBarang.vue?vue&type=template&id=7d7bf37a&"
import script from "./ModalBarang.vue?vue&type=script&lang=js&"
export * from "./ModalBarang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports